import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import Button from "../Buttons/Button";

// Shown when the user has dismissed suggestions. Lets them reactivate via onReset.
// Reads no context — entirely self-contained with its single callback prop.
const SimilarAnswersDismissedPrompt = ({ onReset }) => {
  const t = useFormatMessage();
  const dismissedDescription = t(intlMessages.dismissedDescription);
  const resetSuggestionsDismissedLabel = t(intlMessages.resetSuggestionsDismissed);

  return (
    <>
      <p className="text-muted text-sm margin-bottom-0">{dismissedDescription}</p>

      <Button
        type="button"
        className="btn btn-primary-inverse btn-sm"
        onClick={onReset}
        label={resetSuggestionsDismissedLabel}
      />
    </>
  );
};

export default SimilarAnswersDismissedPrompt;

const intlMessages = defineMessages({
  dismissedDescription: {
    id: "similarAnswers.dismissedDescription",
    defaultMessage: `Vous ne recevrez plus de suggestions en rapport avec votre
      contribution. Si vous souhaitez réactiver les suggestions, vous pouvez cliquer sur
      le bouton ci-dessous.`
  },
  resetSuggestionsDismissed: {
    id: "similarAnswers.resetSuggestionsDismissed",
    defaultMessage: "Réactiver les suggestions"
  }
});
